export default __webpack_public_path__ + "static/media/lend-key-points.6817e47c.png";